var render, staticRenderFns
import script from "./tTable.vue?vue&type=script&lang=js"
export * from "./tTable.vue?vue&type=script&lang=js"
import style0 from "./tTable.vue?vue&type=style&index=0&id=03ff9a65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff9a65",
  null
  
)

export default component.exports